/**
 * Theme state.
 *
 *   themeChoiceAtom    — user-выбор `auto | light | dark` (persist).
 *   systemDarkAtom     — текущая системная тема (matchMedia).
 *   effectiveThemeAtom — derived: реальный `light | dark`, который и
 *                        отдаём в AntD-провайдер и CSS.
 */

import {atom} from 'jotai';
import {atomWithStorage} from 'jotai/utils';

import type {ThemeMode} from '@styles/tokens';

export type ThemeChoice = 'auto' | ThemeMode;

const THEME_STORAGE_KEY = 'kassir:theme:choice';

export const themeChoiceAtom = atomWithStorage<ThemeChoice>(THEME_STORAGE_KEY, 'auto', undefined, {
  getOnInit: true,
});

export const systemDarkAtom = atom<boolean>(
  typeof window !== 'undefined' && window.matchMedia('(prefers-color-scheme: dark)').matches,
);

export const effectiveThemeAtom = atom<ThemeMode>((get) => {
  const choice = get(themeChoiceAtom);
  if (choice === 'auto') return get(systemDarkAtom) ? 'dark' : 'light';
  return choice;
});
